import Store from '@/store'
import {loginCheck} from './loginCheck'
import projectList from '@/pages/project/list/subComponents/projectList'
const progress = {
  func: [
    {call: 'color', modifier: 'temp', argument: '#ffb000'},
    {call: 'fail', modifier: 'temp', argument: '#6e0000'},
    {call: 'location', modifier: 'temp', argument: 'top'},
    {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
  ]
}

const routes = []
// PAGE를 추가하고 싶다면 아래에 추가
routes.push({path: '/', name: 'Index', component: () => import('@/pages/users/login'), beforeEnter: loginCheck, meta: {progress}})
routes.push({path: '/login', name: 'login', component: () => import('@/pages/users/login'), beforeEnter: loginCheck, meta: {progress: progress}})
routes.push({path: '/overview', name: 'overview', component: () => import('@/pages/overview/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project', name: 'ProjectList', component: () => import('@/pages/project/list/index'), beforeEnter: requireAuth, props: true, meta: {progress, requiresAuth: true}})
routes.push({
  path: '/project/definition/:surveyID',
  name: 'project-definition',
  component: () => import('@/pages/project/projectManaging/definition/index'),
  beforeEnter: requireAuth,
  meta: {progress, requiresAuth: true},
  children: [
    {
      path: '',
      name: 'project-list',
      component: projectList
    }
  ]
})
routes.push({path: '/project/setup/:surveyID', name: 'project-setup', component: () => import('@/pages/project/projectManaging/urls/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/registration', name: 'project registration', component: () => import('@/pages/project/registration/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/edit/:surveyID', name: 'project-edit', component: () => import('@/pages/project/edit/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/urls/:surveyID', name: 'project-urls', component: () => import('@/pages/project/projectManaging/urls/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/quota-settings/:surveyID', name: 'project-quota-settings', component: () => import('@/pages/project/projectManaging/quotaSettings/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/quota-custom-make/:surveyID', name: 'project-quota-custom-make', component: () => import('@/pages/project/projectManaging/quotaSettings/makeQuotaExample'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/miscellaneous/:surveyID', name: 'project-miscellaneous', component: () => import('@/pages/project/projectManaging/miscellaneous/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/result/:surveyID', name: 'project-result', component: () => import('@/pages/project/projectManaging/result/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/admin/:surveyID', name: 'project-admin', component: () => import('@/pages/project/projectManaging/admin/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/progress/:surveyID', name: 'project-progress', component: () => import('@/pages/project/projectManaging/progress/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/manual-sampling/:surveyID', name: 'project-manual-sampling', component: () => import('@/pages/project/projectManaging/manual/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/manual-reminder/:surveyID', name: 'project-manual-reminder', component: () => import('@/pages/project/projectManaging/manual/reminder'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/sampling/:surveyID', name: 'project-sampling', component: () => import('@/pages/project/projectManaging/sampling/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({path: '/project/config/:surveyID', name: 'project-config', component: () => import('@/pages/project/projectManaging/config/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})

routes.push({path: '/error', name: 'error', component: () => import('@/pages/error/index'), meta: {progress, requiresAuth: true}})
routes.push({path: '/users', name: 'users', component: () => import('@/pages/users/index'), meta: {progress}})
routes.push({path: '/users/profile/:mode', name: 'Profile', component: () => import('@/pages/users/profile'), beforeEnter: requirePassword, meta: {progress, requestPassword: true}})
routes.push({path: '/users/create/:group', name: 'Create', component: () => import('@/pages/users/create'), meta: {progress}})
routes.push({path: '/users/3rd-party-login', name: 'users-3rd-party-login', component: () => import('@/pages/users/3rdPartyLogin'), meta: {progress}})

routes.push({path: '/users/small-chat/:objectID/:roomID?/:messageID?', name: 'small-chat', component: () => import('@/pages/users/smallChat/index'), props: true, meta: {progress, requiresAuth: true}})
routes.push({path: '/users/send-all', name: 'send-all-message', component: () => import('@/pages/users/smallChat/sendAll'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push({name: 'developmentSpec', path: '/guide/spec', component: () => import('@/pages/guide/spec'), meta: {progress}})
routes.push({path: '/admin/join-history/:surveyID?', name: 'join history', component: () => import('@/pages/admin/joinHistory/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/notice', name: 'notice', component: () => import('@/pages/admin/notice/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/reward-batch/:surveyID?', name: 'reward-batch', component: () => import('@/pages/admin/rewardBatch/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/summary', name: 'admin-summary', component: () => import('@/pages/admin/summary/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/buyer-summary', name: 'buyer-summary', component: () => import('@/pages/admin/buyer/summary'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/supplier-index', name: 'supplier-index', component: () => import('@/pages/admin/supplier/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/watch-queue', name: 'watch-queue', component: () => import('@/pages/admin/watchQueue/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/intro-html-manage', name: 'intro-html-manage', component: () => import('@/pages/admin/introHtmlManage/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})
routes.push({path: '/admin/profile-survey', name: 'profile-survey', component: () => import('@/pages/admin/profileSurvey/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true, admin: true}})

routes.push({path: '/panel-supplier/summary', name: 'supplier-summary', component: () => import('@/pages/supplier/summary/index'), beforeEnter: requireAuthSupplier, meta: {progress, requireAuth: true, supplier: true}})
routes.push({path: '/panel-supplier/joinHistory/:surveyID', name: 'supplier-join-history', component: () => import('@/pages/supplier/joinHistory/index'), beforeEnter: requireAuthSupplier, meta: {progress, requireAuth: true, supplier: true}})
routes.push({path: '/social/board/list', name: 'social-board-list', component: () => import('@/pages/social/board/list/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true}})
routes.push({path: '/social/board/detail/:_id', name: 'social-board-detail', component: () => import('@/pages/social/board/detail/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true}})
routes.push({path: '/social/board/new', name: 'social-board-new', component: () => import('@/pages/social/board/edit/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true}})
routes.push({path: '/social/board/edit/:_id', name: 'social-board-edit', component: () => import('@/pages/social/board/edit/index'), beforeEnter: requireAuth, meta: {progress, requireAuth: true}})

routes.push({path: '/project/manual-except/:surveyID', name: 'project-manual-except', component: () => import('@/pages/project/projectManaging/except/index'), beforeEnter: requireAuth, meta: {progress, requiresAuth: true}})
routes.push(...[
  { path: '/404', component: () => import('@/pages/error/index') },
  { path: '*', redirect: '/404' }
])

function requirePassword (to, from, next) {
  return new Promise(async (resolve, reject) => {
    if (Store.getters.accessToken) {
      try {
        await Store.dispatch('verify', {})
        to.params.password = 'true'
        return resolve(next())
      } catch (error) {
        if (error.response.status === 401) return resolve(next('/login'))
      }
    } else {
      return resolve(next('/login'))
    }
  })
}

function requireAuthSupplier (to, from, next) {
  return new Promise(async (resolve, reject) => {
    if (Store.getters.accessToken) {
      const {supplier, userGroupID} = await Store.dispatch('verify', {})
      if (supplier && userGroupID) return resolve(next())
      await Store.dispatch('logout')
      return resolve(next('/login'))
    } else {
      await Store.dispatch('logout')
      return resolve(next('/login'))
    }
  })
}

function requireAuth (to, from, next) {
  return new Promise(async (resolve, reject) => {
    if (Store.getters.accessToken) {
      try {
        const {supplier} = await Store.dispatch('verify', {})
        return resolve(supplier ? next(`/panel-supplier/summary`) : next())
      } catch (error) {
        console.log(error)
        if (error.response.status === 401) {
          await Store.dispatch('logout')
          return resolve(next('/login'))
        }
      }
    } else {
      await Store.dispatch('logout')
      return resolve(next('/login'))
    }
  })
  /*

  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (Store.getters.accessToken === null) return next('/login')
    try {
      // await Store.dispatch('verify', { accessToken: Store.getters.accessToken })
      await Store.dispatch('verify', {})
      return next()
    } catch (error) {
      if (error.response.status === 401) {
      }
      return next('/login')
    }
  } else if (to.matched.find(r => r.meta.requestPassword)) {
    to.params.password = 'true'
    return next()
  } else {
    return next()
  }
   */
}

export default routes



// WEBPACK FOOTER //
// ./src/router/routerPath.js